module.exports = __webpack_public_path__ + "static/media/tap.c14e3e7b.mp3";